import { ToolbarItem } from "./toolbaritem";

export class ToggleToolbarItem extends ToolbarItem {

  /**
   * @inheritdoc
   */
  constructor(imageEditor, name, element) {
    super();
    this.name = name;

    if (element instanceof HTMLElement) {
      this.element = element;
    } else {
      this.element = document.querySelector(element);
    }

    this.imageEditor = imageEditor;

    this.element.addEventListener("click", (evt) => {
      this.onClick();
      this.setActive(!this.isActive)
    })
  }

  /**
   * @inheritdoc
   */
  setActive(value) {
    this.isActive = value;

    if(value){
      this.element.classList.add("active");
    } else {
      this.element.classList.remove("active");
    }
  }

}